// v2.19.28 — OnboardingGate : composant global qui décide d'afficher
// OnboardingAddressModal post-login si le user n'a pas d'adresse revendiquée.
// Branché une seule fois dans App.js, écoute l'event "civ:auth-changed".
import { useEffect, useState } from "react";
import { useAuth } from "@/hooks/useAuth";
import OnboardingAddressModal from "@/components/OnboardingAddressModal";

const EXTRAS_KEY = "aya_login_extras";
// Capturé au chargement du module + persisté en session : le SW PWA peut forcer
// un reload complet qui perd le query param (?force_onboarding=1, test visuel).
const FORCE_ONBOARDING = (() => {
  if (typeof window === "undefined") return false;
  try {
    if (new URLSearchParams(window.location.search).has("force_onboarding")) {
      sessionStorage.setItem("aya_force_onboarding", "1");
      return true;
    }
    return sessionStorage.getItem("aya_force_onboarding") === "1";
  } catch (_) { return false; }
})();

function _readExtras() {
  try {
    const raw = sessionStorage.getItem(EXTRAS_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (_) { return null; }
}

export default function OnboardingGate() {
  const { user, token } = useAuth();
  const [open, setOpen] = useState(false);
  const [seenCount, setSeenCount] = useState(0);

  useEffect(() => {
    if (!user || !token) { setOpen(false); return; }
    if (user.address_prompt_dismissed) { setOpen(false); return; }
    const extras = _readExtras();
    // On déclenche uniquement quand l’extras récent indique pas d’adresse.
    // Cela évite l’affichage à chaque refresh (où l’event n’est pas redéclenché).
    if (extras && extras.has_address === false) {
      setSeenCount(user.address_prompt_seen_count || 0);
      setOpen(true);
      sessionStorage.removeItem(EXTRAS_KEY);
    }
  }, [user, token]);

  const handleClose = () => setOpen(false);
  const force = FORCE_ONBOARDING;
  return <OnboardingAddressModal open={open || force} token={token} seenCount={force ? 1 : seenCount} onClose={handleClose} />;
}
